export default {
  route: {
    homePage:'首頁',
    dataDisplay:'資料展示',
    atlas:'地圖',
    journal:'日誌',
    details:'詳情',
   
    systemSetting:'系統設定',
    loginAccount:'帳號管理',
    merchants:'商家管理',
    devices: "設備管理",
    material: "物料管理",
    deviceConfig: "設備配置",
    productCenter: "出品管理",
    dataCenter: "資料中心",
    maintenance: "維運管理",
    filesCenter:'文件管理',
    menuSetting:'菜單設置',
    organization:'用戶組織',
    loginAccount:'賬號列表',
    authorization:'角色管理',
    merchants:'商家列表',
    deviceList:'設備列表',
    channelCategory:'通道類型',
    productCategory:'出品類型',
    optionCategory:'規格類型',
    optionList:'規格列表',
    storeAccount:'店舖帳號',
    stores:'店舖管理',
    modelName:'設備名稱/型號',
    category:'物料類型',
    configDistribute:'通道下發',
    devicesChannels:'設備通道',
    productsList5:'出品列表5',
    menuDistribute:'菜單下發',
    storeMenu:'店舖菜單',
    merchantsData:'商家統計數據',
    devicsData:'設備統計數據',
    productionData:'設備出品數據',
    maintanenceData:'設備售後數據',
    devicesWorkingData:'設備使用數據',
    afterSalesReminder:'售後提示',
    maintenanceTips:'保養提示',
    fileUpgrade:'文件升級',
    dataDowloan:'數據下載',
    materialList:'物料列表',
    accessoriesCategory:'小吃類型',
    accessoriesList:'小吃列表',
    businessCenter: '業務中心',
    appsBanner:'App橫幅展示',
    advertisement:'廣告清單',
    advertBind:'廣告綁定',
    advertDistribute:'廣告下發',
    membersCenter:'會員名單',
    orderCenter:'訂單清單',
    packBag:'打包袋子',
    appsCenter:'app管理',
    productsList2:'出品列表2',
    XTSeriesData:'配料機數據',
    productionData:'出品數據',
    materialDate:'物料數據',
    qualityData:'單杯數據',
    alertsLog:'故障日誌',
    cleaningLog:'清洗記錄',
    coffeeData:'咖啡機數據',
    coffeeSumData:'品質數據',
    taxCenter:'稅務中心',
    taxManagement:'稅務管理',
    taxAllocation:'稅務配置',
    dataOfTeaExtractorMachine:'萃茶機數據',
    dataOfBlendExtractorMachine:'冰沙機數據',
    beverageOutputData:'出品數據',
    singleCupData:'單杯數據',
    faultLog:'故障日誌',
    deliveryPlatform:'外買平台',
    uber:'Uber',
    otherProducts:'其他產品',
    listOfTeaExtractsProducts:'萃茶出品清單',
    machineDebug:'設備調試',
    presetCommand:'預設指令',
    commandConfiguration:'命令配置',
    operationAndMaintenanceServices:'維運服務',
    productionList:'出品清單',
    smallMaterial:'小料列表',
    takeoutProducts:'外送產品',
    pointRule:'積分規則',
    couponManagement:" 优惠券管理",
    couponList:"  优惠券列表",
    additionalProducts:'额外产品',
    type:'类型',
    taxAllocation:'税务配置',
    produce:'产品',
    produceList4:'出品列表4',
    },
    acoount: {
      enterpriseName: '商家名稱',
      account: '帳號',
      password: '密碼',
      confirmPassword: '確認密碼',
      roleTitle:'角色職稱',
      roleName:'角色名稱',
      phone:'手機號碼',
      email:'郵箱',
      idNumber:'證件號碼',
      workAddress:'工作地址',
      status:'狀態',
      onDuty:'在崗',
      leaveDuty:'離職',
      takeVacationrm:'休假',
      disable:'禁用',
      profilePicture:'頭像',
      confirmPasswordCannotBeEmpty:'確認密碼不能為空',
      inconsistentPasswordInput:'密碼輸入不一致',
      emailFormatError:'郵件信箱格式錯誤',
      phoneNumberFormatError:'手機號碼格式錯誤',
      notes:'備註',
      empower:'授權',
      contactInformation:'聯絡方式',
      userOrganizationType:'用戶組織類型',
      userOrganizationName:'用戶組織名稱',
      describe:'描述',
      available:'可用',
      deactivate:'停用',
     
      },
      merchant: {
        account: '登陸帳號',
        password: '密碼',
        store: '店鋪',
        status:'狀態',
        available:'正常',
        deactivate:'停用',
        merchantName:'商家名稱',
        businessLicense:'營業執照',
        frontIDCard:'證件照正面',
        backIDCard:'證件照反面',
        head:'負責人',
        Telephone:'聯絡電話',
        userOrganization:'使用者組織',
        businessAddress:'註冊地址',
        trade:'營業',
        closeBusiness:'歇業',
        superior:'上級',
        supervisorSubordinateRelation:'上下級關係',
        clickView:'點擊查看',
        business:'商家',
        country:'國家',
        address:'地址',
        shopNames:'店鋪名稱',
        storeType:'店鋪類型',
        selfService:'自助',
        askFor:'自取',
        SelfPickupTakeoutShop:'自取+外帶店',
        selfServicePickUpTakeout:'自助+自取+外送',
        businessHours:'營業時間',
        closingTime:'打烊時間',
        operatingCycle:'營業週期',
        Monday:'週一',
        Tuesday:'週二',
        Wednesday:'週三',
        Thursday:'週四',
        Friday:'週五',
        Saturday:'週六',
        Sunday:'週日',
        picture:'圖',
        vatNumber:'VAT增值稅號',
        kvtCompanyRegistrationNumber:'KVK公司註冊號碼',
        POSAPIKey:'POS API Key',
        POSAccount:'POS Account',
        APPAPIKey:'APP API Key',
        APPAccount:'APP Account',
        APPClientKey:'APP Client Key',
       
        },
        device:{
          deviceType:'設備類型',
          totalDevice:'設備總數',
          passConfigName:"名稱",
          offLineDevice:'離線設備',
          materialShortageDevice:'缺料設備',
          alertingDevice:'警報設備',
          lockDevice:'鎖機設備',
          maintenanceDevice:'需要保養設備',
          businessInformation:'設備業務資料',
          deviceId:'設備ID',
          deviceModel:'型號',
          dealer:"零售商",
          deviceImie:'設備編碼',
          equipmentSerialNumber:'設備序號',
          posNumber:'刷卡機編碼',
          store:'店鋪',
          location:'設備位置',
          none:'暫無',
          log:"日誌",
          fault:"故障",
          normal:"正常",
          offline:"離線",
          onLine:"在綫",
          isFault:"是否有故障",
          type:"類型",
          fullyAutomatic:"全自動",
          semiAutomatic:"半自動",
          availableMerchants:"可使用商家",
          faultStatistics:"故障統計",
          basicMaintenance:"基礎保養",
          deepMaintenance:"深度保養",
          onLineDevice:'在線設備',
          },
          produce: {
          name: '名稱',
          price: '價格',
          uberPrice: 'Uber單價',
          matterType: '物料類型',
          normType: '規格類型',
          matter: '物料',
          min: '最小值',
          max:'最大值',
          shelfLife:'保鮮期',
          unit:'單位',
          hour:'小時',
          step1:'產品資料',
          step2:'產品物料',
          step3:'產品配方',
          step4:'配方組合',
          step5:'產品小料',
          produceName:'出品名稱',
          produceCode:'出品編碼',
          produceType:'出品類型',
          showSnacks:'顯示小吃',
          yes:'是',
          no:'否',
          describe:'描述',
          order:'順序',
          value:'值',
          unit:'單位',
          norm:'規格',
          select:'選擇',
          step:'步驟',
          matterSequence:'物料順序',
          action:'操作',
          freeSnacks:'免費小料',
          feeBasedMaterials:'收費小料',
          nextStep:'下一步',
          back:'上一步',
          save:'保存',
          saveUpdate:'儲存更新',
          productList:'出品選單',
          selectProduct:'選擇出品',
          menuSort:'排序',
          produceImport:'出品導入',
          bind:'綁定',
          smallMatterType:'小​​料類型',
          listing:'上架',
          isSales:'可下單',
          productListName:"輸入出品選單名稱",
          Text1:'輸入出品名稱',
          Text2:'商家',
          Text3:'物料',
          Text4:'小料',
          Text5:'飲品',
          Text6:'小吃',
          Text7:'新增配方',
          Text8:'更新',
          Text9:'該產品編碼已存在',
          Text10:'請完善產品資訊',
          Text11:'茶品',
          Text12:'第一段',
          Text13:'第二段',
          Text14:'第三段',
          Text15:'出',
          Text16:'不出',
          Text17:'範圍:',
          Text18:'茶葉量:',
         
          },
  business: {
   name: '名稱',
   type: '類型',
   homepage: '首頁',
   advertisingList: '廣告清單',
   pictureOrVideo: '圖片/影片',
   addProductAdvertisements:'新增產品廣告',
   AddImagesOrvideos:'新增圖片/影片',
   userName: '使用者名稱',
   email: '信箱',
   sex: '性別',
   birthday: '生日',
   phone: '手機號碼',
   walletBalance: '錢包餘額',
   integral: '積分',
   orderNo: '訂單號碼',
   pickupCode: '取餐碼',
   store: '店鋪',
   amount: '訂單金額',
   payAmount: '實付金額',
   receiptsPrice: '實收金額',
   discount: '優惠',
   orderStatus: '訂單狀態',
   toBePaid: '待支付',
   paid: '已支付',
   processing: '處理中',
   completed: '已完成',
   orderCancellation: '訂單取消',
   orderRejection: '訂單拒絕',
   paymentMethod: '付款方式',
   wallet: '錢包',
   cash: '現金',
   pos: '刷卡機',
   produce: '產品',
   unitPrice: '單價',
   number: '數量',
   parameter: '參數',
   totalTaxAmount:'總稅額',
   taxName:'稅名',
   taxAmount:'稅額',
   taxRate:'稅率',
   orderType: '訂單類型',
   pack: '打包',
   dineIn: '堂食',
  
   },
   file: {
   name: '名稱',
   version: '版本',
   keyword: '標識',
   file:'文件',
   upload:'上傳'
  
   },
   coupon: {
   Text1: '名稱',
   Text2: '優惠金額',
   Text3: '消耗積分',
   Text4:'狀態',
   Text5:'詳情',
   Text6:'可用',
   Text7:'不可用',
   Text8:'有效天數'
  
   },
   pass: {
    name: '名稱',
    pass: '通道',
    passNumber: '通道號',
    preDischargeTime: '預出料時間',
    addPass:'新增通道',
    bindPass:'通道綁定',
    passConfigName:'通道配置名稱'
   
    },
    operation:{
    orderAmount:"訂單金額",
    orderQuantity:"訂單數量",
    actualAmountReceived:"實收金額",
    top_10_beverage_rankings:"飲品榜Top10",
    sales_revenue:"銷售額",
    order_quantity:"訂單數量",
    payment_method:"付款方式",
    real_time_orders_on_the_hour:"整點即時訂單",
    },
    dataCenter:{
    Text1:"內容",
    Text2:"數據",
    Text3:"銷售量/杯",
    Text4:"銷售額/元",
    Text5:"消耗物料/g",
    Text6:"月",
    Text7:"日",
    Text8:"時",
    Text9:"圖表",
    Text10:"單杯消耗物料",
    Text11:"排名",
    Text12:"出品消耗物料",
    Text13:"設備消耗物料",
    Text14:"百分比",
    Text15:"排名",
    Text16:"銷售量",
    Text17:"銷售額",
    Text18:"時間/S",
    Text19:"出品銷售量",
    Text20:"出品銷售額",
    Text21:"設備銷售量",
    Text22:"設備銷售額",
    Text23:"總杯數",
    Text24:"總配方量/克",
    Text25:"實際總配方量/克",
    Text26:"壞杯量/杯",
    Text27:"壞杯率/%",
    Text28:"誤差率/%",
    Text29:"出品名稱",
    Text30:"製作方式",
    Text31:"掃碼",
    Text32:"產品",
    Text33:"手動",
    Text34:"訂單號",
    Text35:"店鋪",
    Text36:"單價",
    Text37:"配方總量(g)",
    Text38:"實際出杯量(g)",
    Text39:"出杯時間",
    Text40:"誤差(%)",
    Text41:"壞杯",
    Text42:"正常",
    Text43:"製作完成",
    Text44:"製作失敗",
    Text45:"完成時間",
    Text46:"模式",
    Text47:"通道",
    Text48:"狀態",
    Text49:"未完成",
    Text50:"完成",
    Text51:"出品名稱",
    Text52:"杯數",
    Text53:"總價",
    Text54:"訂單統計",
    Text55:"訂單列表",
    Text56:"訂單金額",
    Text57:"訂單數量",
    Text58:"實收金額",
    Text59:"產品金額",
    Text60:"茶葉量",
    Text61:"出水量",
    Text62:"銷售量/桶",
    Text63:"桶",
    Text64:"偏酸/萃取過短",
    Text65:" 均衡/萃取中等",
    Text66:"偏苦/萃取過度",
    Text67:"味苦/濃度低",
    Text68:"中等",
    Text69:"強/濃度高",
    Text70:"萃取時間",
    Text71:"水粉比",
    strongBalance:"強平衡",
    weakBalance:"弱平衡",
    mediumAcid:"中酸",
    strongAcid:"強酸",
    goldenCup:"金杯",
    weakAcid:"弱酸",
    bitter:"苦",
    strongBitter:"強苦",
    weakBitter:"弱苦",
    },
    taxation:{
      Text1:"稅名",
      Text2:"稅率",
      Text3:"基數",
      Text4:"備註",
      Text5:"國",
      Text6:"型別",
      Text7:"堂食",
      Text8:"打包",
      Text9:"產品類型",
      Text10:"稅種",
      Text11:"平台外賣",
      },
      uber:{
      Text1:"uber店舖",
      Text2:"平台店鋪",
      Text3:"訂單狀態",
      Text4:"店鋪狀態",
      Text5:"已綁定",
      Text6:"未綁定",
      Text7:"同步"
     
      },
      login: {
      title: '系統登入',
      logIn: '登入',
      username: '帳號',
      password: '密碼',
      readAndAgree:'已閱讀並同意',
      pleaseCheckThePrivacyAgreement:'請勾選隱私協議',
      termTip:'《服務協議》',
      term:'《條款及細則》',
      Text1:'請輸入帳號',
      Text2:'請輸入密碼'
     
     
      },
      navbar: {
      logOut: '退出登錄',
      dashboard: '首頁',
      github: '項目地址',
      screenfull: '全螢幕',
      theme: '換膚',
      size: '佈局大小'
      },
      tagsView: {
      refresh: '刷新',
      close: '關閉',
      closeOthers: '關閉其它',
      closeAll: '關閉所有'
      },
      common:{
      tower:'台',
      yuan:'元',
      cup:'杯',
      place:'位',
      individual:'個',
      language:'語言',
      success:'成功',
      fail:'失敗',
      createTime:'創建時間',
      all:'全部',
      common:'全部',
      sureDel:'確定刪除',
      tip:'提示',
      status:'狀態',
      bing:'綁定',
      pleaseSelectDevice:'請選擇設備',
      pleaseSelectMenu:'請選擇菜單',
      pleaseSelectModel:'請選擇型號',
      pleaseSelect:'請選擇',
      code:'編碼',
      entering_the_platform:'進入平台',
      date:"日期",
      address_fail:"地址不正確",
      back:'返回',
      pleaseEnter:'請輸入',
      uploadImageBtn:'點擊上傳圖片',
      uploadImageBtnTip:'僅支援上傳JPG 格式與PNG格式（限制10M以內）',
      uploadVideoBtn:'點選上傳影片',
      uploadVideoBtnTip:'僅支援上傳mp4或MP4檔（限制50M以內）',
      videoPlayTip:' 您的瀏覽器不支援影片播放'
     
      },
      table:{
        search: '查詢',
        detail:'詳情',
        actions: '操作',
        edit: '編輯',
        publish: '發布',
        delete: '刪除',
        cancel: '取 消',
        confirm: '確 定',
        add:'新增',
        copy:'複製',
        produceCodeRule:'編碼規則',
        batchDeletion:'批量刪除',
        batchImport:'批量導入',
        batchCopy:'批量複製',
        export:'數據導出',
        import:'導入',
        templateDownload:'模板下載',
        dragAndDropUpload:'將文件拖曳到此處，或點選上傳',
        picture:'圖',
        resetPwd:'重設密碼'
        },
        coffeeData:{
        Text1:"浸泡流量",
        Text2:"浸泡時間",
        Text3:"萃取流量",
        Text4:"萃取壓力",
        Text5:"萃取溫度",
        Text6:"訂單類型",
        Text7:"狀態",
        Text8:"出杯時間",
        Text9:"粉量",
        Text10:"設備編碼",
        Text11:"出品名稱",
        }
}


// WEBPACK FOOTER //
// ./src/lang/zh-tw.js